<script>
import DataLayer from './../../services/data-layer/index'
import Layout from './../layouts/main'
import GenreGridBlock from '@components/genre/genre-grid-block'

export default {
    page() {
        const title = 'Your Genres'
        const description = 'Your Genres'
        return {
            title,
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },

                { property: 'twitter:title', vmid: 'twitter:title', content: title },
                { property: 'twitter:description', vmid: 'twitter:description', content: description },
            ],
        }
    },
    components: { Layout, GenreGridBlock },
    data() {
        return {
            isLoading: false,
            allGenres: [],
            followedGenreIds: [],
            favoritesService: DataLayer.favorites,
        }
    },
    computed: {
        membersId() {
            return this.$store.state.auth.currentUser.members_id.id
        },
        genres() {
            return this.allGenres.filter((genre) => this.followedGenreIds.includes(genre.id))
        },
    },
    async mounted() {
        await this.getGenresAndFavorites()
    },
    methods: {
        async getGenresAndFavorites() {
            this.isLoading = true

            const [genresRes, favoritesRes] = await Promise.all([
                DataLayer.genres.getAll(),
                this.favoritesService.getAll({ type: 'genres', membersId: this.membersId })
            ])

            this.allGenres = genresRes.body || []

            const favoriteGenres = favoritesRes.body || []
            this.followedGenreIds = favoriteGenres.map((item) => item.genres_id?.id).filter(Boolean)

            this.isLoading = false
        },
        async handleToggleFollow(genre) {
            await this.favoritesService.remove({ type: 'genres', membersId: this.membersId, id: genre.id })
            this.followedGenreIds = this.followedGenreIds.filter((id) => id !== genre.id)
        },
    },
}
</script>

<template>
    <Layout>
        <BaseContent title="Your Genres">
            <BaseSection padded>
                <BaseSpinner v-if="isLoading"/>
                <GenreGridBlock
                    v-else-if="genres.length > 0"
                    :genres="genres"
                    :followed-genre-ids="followedGenreIds"
                    @toggle-follow="handleToggleFollow"
                />
                <BaseEmptyList
                    v-else
                    :error="{
                        title: `You are not following any genres.`,
                        paragraph: 'Following genres helps us recommend similar genres.',
                    }"
                />
            </BaseSection>
        </BaseContent>
    </Layout>
</template>

<style lang="scss" scoped>
@use '@design' as *;
</style>
